import React from "react";
import PropTypes from "prop-types";
// Material imports
import { useTheme } from "@mui/styles";
import withStyles from "@mui/styles/withStyles";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import CircularProgress from "@mui/material/CircularProgress";
//Limitless imports
import { useExpertMessageContext } from "../../../../../../expert";
import MessageDuplicateDialogueDialog from "../../../../dialogs/message-duplicate-dialogue-dialog/MessageDuplicateDialogueDialog";
const FailedToSendSuffix = ({
  classes,
  dialogue
}) => {
  const [loading, setLoading] = React.useState(false);
  const [showDuplicateDialogueWarning, setShowDuplicateDialogueWarning] = React.useState(false);
  const {
    resubmitDialogue,
    setDialogueError,
    isDupeDialogue
  } = useExpertMessageContext();
  const theme = useTheme();
  const handleResubmit = () => {
    if (isDupeDialogue(dialogue.body)) {
      setShowDuplicateDialogueWarning(true);
    } else {
      handleResubmitDialogue();
    }
  };
  const handleSendDupeDialogue = () => {
    handleCancelDupeDialogue();
    handleResubmitDialogue();
  };
  const handleCancelDupeDialogue = () => {
    setShowDuplicateDialogueWarning(false);
  };
  const handleResubmitDialogue = () => {
    setLoading(true);
    resubmitDialogue(dialogue, success => {
      if (success) {
        setLoading(false);
        setDialogueError(null);
      } else {
        setTimeout(() => setLoading(false), 5000);
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.iconContainer
  }, !loading && /*#__PURE__*/React.createElement(ErrorIcon, {
    onClick: handleResubmit,
    sx: {
      color: loading ? "disabled" : theme.palette.error.dark
    }
  }), loading && /*#__PURE__*/React.createElement(CircularProgress, {
    color: "secondary"
  }), showDuplicateDialogueWarning && /*#__PURE__*/React.createElement(MessageDuplicateDialogueDialog, {
    onSendClick: handleSendDupeDialogue,
    onCancelClick: handleCancelDupeDialogue
  }));
};
const styles = () => ({
  iconContainer: {
    alignSelf: "center",
    position: "relative"
  }
});
export default withStyles(styles)(FailedToSendSuffix);
FailedToSendSuffix.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogue: PropTypes.object.isRequired
};